import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import TertiaryButton from "../../../../_utils/CommonButtons/TertiaryButton";

import { ownerListViewAllAcc } from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { beneViewAllAcc } from "../../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { beneInternalViewAllAcc } from "../../../../../redux/features/internalApi/internalApi.js";
import { beneTxnViewAllAcc } from "../../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { internalTxnViewAll } from "../../../../../redux/features/internalTransaction/internalTransactionViewAll.js";

import { toast } from "react-toastify";
import { toast_position } from "../../../../../redux/features/Settings/Authorization";

import { getUsers } from "../../../../../redux/features/Settings/Management/Users";
import SingleSelectDropDownComponent from "../../../../_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import SingleSelectDropDownComponentWithIcon from "../../../../_utils/CommonDropdown/SingleSelectDropdownWithIcon/index.jsx";

const daysOptions = [
  { name: "Last 7 days", value: "last 7 days" },
  { name: "Last 28 days", value: "last 28 days" },
];

const amountOptions = [
  { name: "Absolute (amount)", value: "" },
  { name: "Amount in lakhs", value: "Lakhs" },
  { name: "Amount in crores", value: "Crores" },
  { name: "Amount in millions", value: "Millions" },
  { name: "Amount in billions", value: "Billions" },
];
// const disableInternal = autoFetch === true && flow === "bene";

// const txnOptionsArray = disableInternal
//   ? [{ name: "Beneficiary transactions", value: "bene" }]
//   : [
//       { name: "Beneficiary transactions", value: "bene" },
//       { name: "Internal transactions", value: "internal" },
//     ];

const GraphHeader = ({
  noData,
  handlingOptionsRequired,
  titleText,
  flowType,
  flow,
  autoFetch,
}) => {
  const dispatch = useDispatch();

  const [optionType, setOptionType] = useState("");

  // states

  const [selectedDays, setSelectedDays] = useState(daysOptions[0]);

  const [selectedAmount, setSelectedAmount] = useState(amountOptions[0]);

  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState("");
  const disableInternal = autoFetch === true && flow === "bene";
  const disableBene = autoFetch === true && flow === "internal";

  const txnOptionsArray = disableInternal
    ? [{ name: "Beneficiary transactions", value: "bene" }]
    : disableBene
      ? [{ name: "Internal transactions", value: "internal" }]
      : [
          { name: "Beneficiary transactions", value: "bene" },
          { name: "Internal transactions", value: "internal" },
        ];

  const [selectedTxnOption, setSelectedTxnOption] = useState(
    txnOptionsArray[0],
  );

  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [labelsOptions, setLabelsOptions] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState(null);

  const [favLoading, setfavLoading] = useState(false);
  const [empLoading, setEmpLoading] = useState(false);
  const [labelsLoading, setLabelsLoading] = useState(false);

  // propagate selected options
  useEffect(() => {
    handlingOptionsRequired.forEach((opt) => {
      setOptionType(opt.type);
      if (opt.type === "days") opt.setterState(selectedDays.value);
      if (opt.type === "amounts") opt.setterState(selectedAmount.value);
      if (opt.type === "allAccounts" && selectedAccount) {
        opt.setterState(selectedAccount.value);
      }
      if (opt.type === "favouriteAccounts" && selectedAccount) {
        opt.setterState(selectedAccount);
      }
      if (opt.type === "txnOption") {
        opt.setterState(selectedTxnOption.value);
      }
      if (opt.type === "employees" && selectedEmployee) {
        opt.setterState(selectedEmployee.value);
      }
      if (opt.type === "labels" && selectedLabels) {
        opt.setterState(selectedLabels.value);
      }
    });
  }, [
    selectedDays,

    selectedAmount,

    selectedAccount,
    selectedTxnOption,

    selectedEmployee,
    handlingOptionsRequired,
    ,
  ]);

  // fetch accounts
  useEffect(() => {
    const fetchAccounts = async () => {
      setfavLoading(true);

      const firstPage = await dispatch(
        optionType === "favouriteAccounts"
          ? ownerListViewAllAcc({
              favourite: "Y",
              connected_banking: "Y",
              page_no: 1,
              page_size: 100,
            })
          : ownerListViewAllAcc({
              page_no: 1,
              connected_banking: "Y",
              page_size: 100,
            }),
      );

      if (
        firstPage?.payload?.status &&
        firstPage.payload.owner_accounts?.length
      ) {
        const totalPages = firstPage.payload.title?.total_pages;

        let allAccounts = [...firstPage.payload.owner_accounts];

        // fetch remaining pages if any
        if (totalPages > 1) {
          for (let i = 2; i <= totalPages; i++) {
            const res = await dispatch(
              optionType === "favouriteAccounts"
                ? ownerListViewAllAcc({
                    favourite: "Y",
                    page_no: i,
                    connected_banking: "Y",
                    page_size: 100,
                  })
                : ownerListViewAllAcc({
                    page_no: i,
                    connected_banking: "Y",
                    page_size: 100,
                  }),
            );

            if (res?.payload?.status && res.payload.owner_accounts?.length) {
              allAccounts = [...allAccounts, ...res.payload.owner_accounts];
            } else {
              console.error(`Failed to fetch page ${i}`);
            }
          }
        }

        const allOwnerAcId = allAccounts.map((val) => val.id);

        const options = allAccounts.map((val) => ({
          name: val.bank_acc_no,
          label: val.bank_acc_no,
          icon: "https://q2pay.in/new_assets/common/detail_page/favourite_filled.svg",
          value: [val.id],
        }));

        // first option is "All accounts"

        let formattedOptions;

        if (optionType === "allAccounts") {
          formattedOptions = [
            {
              name: "All owner accounts",
              value: allOwnerAcId, // same as owner accounts example
            },
            ...options,
          ];
        } else {
          formattedOptions = options;
        }
        setAccountOptions(formattedOptions);
        setSelectedAccount(formattedOptions[0]); // default first
      }
      setfavLoading(false);
    };

    if (optionType === "favouriteAccounts" || optionType === "allAccounts")
      fetchAccounts();
  }, [dispatch, optionType]);

  // fetch labels

  useEffect(() => {
    const fetchLabels = async () => {
      setLabelsLoading(true);

      const response =
        flowType === "beneAccount"
          ? await dispatch(beneViewAllAcc({}))
          : flowType === "intAccount"
            ? await dispatch(beneInternalViewAllAcc({}))
            : flowType === "beneTxn"
              ? await dispatch(beneTxnViewAllAcc({}))
              : flowType === "intTxn"
                ? await dispatch(internalTxnViewAll({}))
                : null;

      if (
        response?.payload?.status &&
        response.payload.summary.available_labels
      ) {
        let allLabelsOptions = [];
        response.payload.summary.available_labels.map((val) =>
          allLabelsOptions.push(val.id),
        );

        const options = response.payload.summary.available_labels.map(
          (val) => ({
            name: val,
            value: val,
          }),
        );

        let formattedOptions = [];
        formattedOptions = [
          {
            name: "All labels",
            value: allLabelsOptions.toString(),
          },
          ...options,
        ];

        setLabelsOptions(formattedOptions);
        setSelectedLabels(formattedOptions[0]); // default first
      }
      setLabelsLoading(false);
    };

    fetchLabels();
  }, [dispatch, optionType]);

  //fetch employees
  useEffect(() => {
    const fetchUsers = async () => {
      setEmpLoading(true);

      try {
        // fetch the first page
        const firstPage = await dispatch(
          getUsers({ page_no: 1, page_size: 100 }),
        );

        if (firstPage?.payload?.status && firstPage.payload.employees?.length) {
          const totalPages = firstPage.payload.title?.total_pages;

          let allEmployees = [...firstPage.payload.employees];

          // fetch remaining pages if any
          if (totalPages > 1) {
            for (let i = 2; i <= totalPages; i++) {
              const res = await dispatch(
                getUsers({ page_no: i, page_size: 100 }),
              );

              if (res?.payload?.status && res.payload.employees?.length) {
                allEmployees = [...allEmployees, ...res.payload.employees];
              } else {
                console.error(`Failed to fetch page ${i}`);
              }
            }
          }

          const allEmployeeIds = allEmployees.map((val) => val.id);

          const options = allEmployees.map((val) => ({
            name: `${val?.first_name || ""} ${val?.last_name || ""}`,
            value: val.id,
          }));

          // first option is "All employees"
          const formattedOptions = [
            {
              name: "All employees",
              value: allEmployeeIds, // same as owner accounts example
            },
            ...options,
          ];

          setEmployeeOptions(formattedOptions);
          setSelectedEmployee(formattedOptions[0]); // default first
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }

      setEmpLoading(false);
    };

    if (optionType === "employees") fetchUsers();
  }, [dispatch, optionType]);
  useEffect(() => {
    if (disableInternal) {
      setSelectedTxnOption({ name: "Beneficiary transactions", value: "bene" });
      handlingOptionsRequired
        ?.find((o) => o.type === "txnOption")
        ?.setterState("bene");
    } else if (disableBene) {
      setSelectedTxnOption({
        name: "Internal transactions",
        value: "internal",
      });
      handlingOptionsRequired
        ?.find((o) => o.type === "txnOption")
        ?.setterState(selectedTxnOption.value);
    }
  }, [disableInternal, disableBene, handlingOptionsRequired]);

  return (
    <div className="flex flex-col w-width-full h-auto">
      {/* Header Top Div */}

      <div
        className={`flex justify-between items-center pl-padding-md rounded-t-border-radius-md h-height-full relative ${autoFetch ? "bg-primary-card" : "bg-primary-nav"}`}
      >
        <div className="justify-start flex items-center gap-gap-sm w-width-md py-padding-sm">
          <img
            className="w-icon-sm h-icon-sm"
            src={"https://q2pay.in/new_assets/common/settings/statistics.svg"}
            alt="Statistics"
          />
          <div className="text-font-sm text-text-primary font-semibold">
            {titleText}
          </div>
        </div>
        {!autoFetch && (
          <div className="justify-end h-[-webkit-fill-available] relative">
            <TertiaryButton
              btnText="Add to home"
              handleFunction={() => {
                toast.info("Feature coming soon.", toast_position);
              }}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-nav-act)"
              isLoading={false}
              borderRadius={true}
              borderRadiusTopRight={true}
              icon={
                "https://q2pay.in/new_assets/common/dashboard/home_unselected_outline.svg"
              }
              hoverOption="white"
              isDisabled={true}
              heightFullRequired={true}
            />
          </div>
        )}
      </div>

      {!noData && (
        <div className="flex Qsmd:flex-row flex-col w-width-full z-z-index-dropdown">
          {handlingOptionsRequired?.map((val) => {
            if (val.type === "days")
              return (
                <div className="flex flex-1">
                  <SingleSelectDropDownComponent
                    options={daysOptions}
                    isOpen={false}
                    selected={selectedDays.value}
                    setSelected={setSelectedDays}
                    disabled={false}
                    placeholder="Last 7 days"
                    type="small"
                    isStatistic={true}
                  />
                </div>
              );

            if (val.type === "amounts")
              return (
                <div className="flex flex-1 bg-primary-act Qsmd:border-l-border  border-primary-bg">
                  <SingleSelectDropDownComponent
                    options={amountOptions}
                    isOpen={false}
                    selected={selectedAmount.value}
                    setSelected={setSelectedAmount}
                    disabled={false}
                    placeholder="Absolute (amount)"
                    type="small"
                    isStatistic={true}
                  />
                </div>
              );

            if (val.type === "allAccounts")
              return (
                <div className="flex flex-1 bg-primary-act Qsmd:border-l-border  border-primary-bg">
                  <SingleSelectDropDownComponent
                    options={accountOptions}
                    isOpen={false}
                    selected={selectedAccount.value}
                    statisticDisplayName={selectedAccount.name}
                    setSelected={setSelectedAccount}
                    disabled={false}
                    placeholder="All owner accounts"
                    type="small"
                    isStatistic={true}
                  />
                </div>
              );
            if (val.type === "favouriteAccounts")
              return (
                <div className="flex flex-1 bg-primary-act Qsmd:border-l-border  border-primary-bg">
                  <SingleSelectDropDownComponentWithIcon
                    options={accountOptions}
                    isOpen={false}
                    selected={selectedAccount}
                    setSelected={setSelectedAccount}
                    disabled={favLoading}
                    placeholder="All owner accounts"
                    type="small"
                    isStatistic={true}
                  />
                </div>
              );

            if (val.type === "txnOption")
              return (
                <div className="flex flex-1 bg-primary-act Qsmd:border-l-border  border-primary-bg">
                  <SingleSelectDropDownComponent
                    options={txnOptionsArray}
                    isOpen={false}
                    selected={selectedTxnOption.value}
                    statisticDisplayName={selectedTxnOption.name}
                    setSelected={setSelectedTxnOption}
                    placeholder="Beneficary transactions"
                    type="small"
                    disabled={disableInternal || disableBene}
                    isStatistic={true}
                  />
                </div>
              );
            if (val.type === "employees")
              return (
                <div className="flex flex-1 bg-primary-act Qsmd:border-l-border  border-primary-bg">
                  <SingleSelectDropDownComponent
                    options={employeeOptions}
                    isOpen={false}
                    selected={selectedEmployee.value}
                    statisticDisplayName={selectedEmployee.name}
                    setSelected={setSelectedEmployee}
                    disabled={empLoading}
                    placeholder="All employee"
                    type="small"
                    isStatistic={true}
                  />
                </div>
              );

            if (val.type === "labels")
              return (
                <div className="flex flex-1 bg-primary-act Qsmd:border-r-border border-b-border Qsmd:border-b-border-base border-primary-bg Qmd:max-w-max_width-md">
                  <SingleSelectDropDownComponent
                    options={labelsOptions}
                    isOpen={false}
                    selected={selectedLabels.value}
                    setSelected={setSelectedLabels}
                    disabled={labelsLoading}
                    placeholder="All employee"
                    type="small"
                    isStatistic={true}
                  />
                </div>
              );

            return null;
          })}
        </div>
      )}
    </div>
  );
};

export default GraphHeader;
